import { render, staticRenderFns } from "./ReturnableOrderItemView.vue?vue&type=template&id=39283267&"
import script from "./ReturnableOrderItemView.vue?vue&type=script&lang=js&"
export * from "./ReturnableOrderItemView.vue?vue&type=script&lang=js&"
import style0 from "./ReturnableOrderItemView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1768404630/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39283267')) {
      api.createRecord('39283267', component.options)
    } else {
      api.reload('39283267', component.options)
    }
    module.hot.accept("./ReturnableOrderItemView.vue?vue&type=template&id=39283267&", function () {
      api.rerender('39283267', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/Return/ReturnableOrderItemView.vue"
export default component.exports